<!-- 🚀 CANDADO DE SEGURIDAD SAAS CORE: APAGA EL SSR EXCLUSIVAMENTE PARA ESTE DIÁLOGO -->
<div ngSkipHydration>
  <div class="container-fluid mt-2 px-3" style="font-size: 0.88rem;">
    
    <!-- Encabezado de Navegación -->
    <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
      <div>
        <h2 class="h5 m-0 fw-bold text-dark">📋 Registrar Identidad en el Address Book</h2>
        <span class="small text-muted font-monospace">F0101 Real-Time Identity Provisioning</span>
      </div>
    </div>

    <!-- Formulario Reactivo Central (Ensanchado a un ancho máximo de 700px para evitar amontonamientos) -->
    <form [formGroup]="personalForm" (ngSubmit)="onSubmit()" class="card shadow-sm border-0 p-3 bg-white mx-auto" style="max-width: 800px; border-radius: 12px;">
      
      <!-- PRIMERA FILA: NOMBRE Y TIPO (RECONFIGURADA CON ESPACIO ERGONÓMICO AMPLIO) -->
      <div class="row g-2 mb-3">
        <!-- INPUT NOMBRE REAL COMPLETO -->
        <div class="col-md-8">
          <div class="form-floating">
            <input type="text" class="form-control text-uppercase" id="nameAlpha" formControlName="nameAlpha" placeholder="Juan Pérez"
                   appUppercase
                   [ngClass]="{'is-invalid': personalForm.get('nameAlpha')?.touched && personalForm.get('nameAlpha')?.invalid}">
            <label for="nameAlpha" class="text-primary fw-bold">Nombre Completo del Personal *</label>
            <div class="invalid-feedback">El nombre es obligatorio (mínimo 4 caracteres).</div>
          </div>
        </div>

        <!-- SELECTOR TIPO DE IDENTIDAD (Ensanchado horizontalmente a col-md-4 con lectura descriptiva completa) -->
        <div class="col-md-4">
          <div class="form-floating">
            <select class="form-select" id="searchType" formControlName="searchType"
                    [ngClass]="{'is-invalid': personalForm.get('searchType')?.touched && personalForm.get('searchType')?.invalid}">
              <option value="">-- Seleccione Tipo --</option>
              <option value="E">E (Staff / Administración)</option>
              <option value="M">M (Técnico / Mecánico)</option>
            </select>
            <label for="searchType" class="text-primary fw-bold">Tipo de Personal *</label>
            <div class="invalid-feedback">El tipo de personal es obligatorio.</div>
          </div>
        </div>
      </div>

      <!-- SEGUNDA FILA: CORREO Y TELÉFONO -->
      <div class="row g-2 mb-2">
        <!-- INPUT CORREO ELECTRÓNICO (OPCIONAL) -->
        <div class="col-md-6">
          <div class="form-floating">
            <input type="text" class="form-control text-uppercase" id="email" formControlName="email" placeholder="nombre@taller.com"
                   appUppercase
                   [ngClass]="{'is-invalid': personalForm.get('email')?.touched && personalForm.get('email')?.invalid}">
            <label for="email">Correo Electrónico Corporativo</label>
            <div class="invalid-feedback">
              <!-- Mensaje tradicional si lo dejan vacío -->
              <span *ngIf="personalForm.get('email')?.hasError('required')">El correo electrónico es obligatorio para el alta del cliente.</span>
              
              <!-- Mensaje tradicional si el formato está mal escrito -->
              <span *ngIf="personalForm.get('email')?.hasError('email')">Por favor ingrese un formato de correo válido.</span>
              
              <!-- MANTENIDO: El mensaje rojo estático abajo del campo que querías conservar -->
              <span *ngIf="personalForm.get('email')?.hasError('correoDuplicado')" class="fw-bold text-danger">
              ⚠️ Correo ya registrado en el sistema. Pertenece a un cliente existente en la base de datos.
              </span>
            </div>            
          </div>
        </div>

        <!-- INPUT TELÉFONO (OPCIONAL) -->
        <div class="col-md-6">
          <div class="form-floating">
            <input type="text" class="form-control font-monospace" id="phone" formControlName="phone" placeholder="5551234567"
                   [ngClass]="{'is-invalid': personalForm.get('phone')?.touched && personalForm.get('phone')?.invalid}">
            <label for="phone">Teléfono de Contacto</label>
            <div class="invalid-feedback">Solo se permiten números, espacios y el signo +.</div>
          </div>
        </div>
      </div>

      <!-- 🎛️ BOTONERA DE ACCIONES COMPATIBLE CON EL ESTILO GENERAL -->
      <div class="d-flex justify-content-end align-items-center gap-2 mt-4 border-top pt-3">
        <button type="button" class="btn btn-sm btn-outline-secondary px-4 fw-bold" (click)="onCancelar()">
          ❌ Cancelar
        </button>
        <button type="submit" class="btn btn-sm btn-success text-white px-4 fw-bold shadow-sm">
          🚀 Guardar Personal F0101
        </button>
      </div>

    </form>
  </div>
</div>